import React from 'react';

const IFrame = (props)=>{
  let { url,height } = props.component;
  let iframestyle={
    border:"1px solid white",
    borderRadius:10,
  }
  return (
    <div className={`form-group nopadding ${props.component.widths.parent}`}>
            <iframe src={url} width="100%" height={height} style={iframestyle}></iframe>
    </div>
  );
}




export default IFrame;
